import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles(theme => ({
  filter: {
    height: 420,
    width: 500,
  },
  siteChip: {
    backgroundColor: theme.palette.warning.main,
  },
}));
